import { combineReducers } from "@reduxjs/toolkit";

import countries from "./countries/countriesSlice";
import optIn from "./optIn/optInSlice";
import psaContactValidation from "./psaContactValidation/psaContactValidationSlice";
import secureData from "./secureData/secureDataSlice";
import secureDataRequest from "./secureDataRequest/secureDataRequestSlice";

const rootReducer = combineReducers({
  optIn,
  countries,
  psaContactValidation,
  secureData,
  secureDataRequest,
});

export default rootReducer;
